<template>
  <v-container class="d-flex flex-wrap justify-center" 
    v-if="Array.isArray(rewards)">
        <v-tooltip top dark v-for="(reward, i) in rewards" :key="i">
          <template v-slot:activator="{ on }">
            <v-img v-on="on" 
            class="ma-1"
            :lazy-src="require('@/assets/animate-logo-white.svg')" 
            :src="encodeURI(`${path}${reward}.png`)" :alt="reward"
            :width="mw" :max-width="mw" 
            contain />
          <!-- aspect-ratio="1" :min-width="w"   :style="{width: w, maxWidth: mw}" -->
          </template>
          <span>{{reward}}</span>
        </v-tooltip>
    </v-container>
    <p v-else>{{rewards}}</p>
</template>
<script>
export default {
    props: ['rewards', 'path', 'w', 'mw']
}

</script>
<!-- <style scoped></style> -->
